import r from "react";
import { createPortal as t } from "react-dom";
import e from "prop-types";
import { useIsomorphicLayoutEffect as n } from "@leafygreen-ui/hooks";
function o(r, t) {
  return function (r) {
    if (Array.isArray(r)) return r;
  }(r) || function (r, t) {
    var e = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != e) {
      var n,
        o,
        a,
        i,
        l = [],
        u = !0,
        c = !1;
      try {
        if (a = (e = e.call(r)).next, 0 === t) {
          if (Object(e) !== e) return;
          u = !1;
        } else for (; !(u = (n = a.call(e)).done) && (l.push(n.value), l.length !== t); u = !0);
      } catch (r) {
        c = !0, o = r;
      } finally {
        try {
          if (!u && null != e.return && (i = e.return(), Object(i) !== i)) return;
        } finally {
          if (c) throw o;
        }
      }
      return l;
    }
  }(r, t) || function (r, t) {
    if (!r) return;
    if ("string" == typeof r) return a(r, t);
    var e = Object.prototype.toString.call(r).slice(8, -1);
    "Object" === e && r.constructor && (e = r.constructor.name);
    if ("Map" === e || "Set" === e) return Array.from(r);
    if ("Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return a(r, t);
  }(r, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function a(r, t) {
  (null == t || t > r.length) && (t = r.length);
  for (var e = 0, n = new Array(t); e < t; e++) n[e] = r[e];
  return n;
}
function i(t) {
  var e = o(r.useState(), 2),
    a = e[0],
    i = e[1];
  return n(function () {
    if (!t) {
      var r = document.createElement("div");
      return document.body.appendChild(r), i(r), function () {
        r.remove();
      };
    }
    i(t);
  }, [t]), a;
}
function l(r) {
  var e,
    o = i(null !== (e = r.container) && void 0 !== e ? e : void 0);
  return n(function () {
    var t;
    o && !r.container && (o.className = null !== (t = r.className) && void 0 !== t ? t : "");
  }, [o, r.container, r.className]), o ? t(r.children, o) : null;
}
l.displayName = "Portal", l.propTypes = {
  children: e.node,
  className: e.string,
  container: e.oneOfType([e.node, e.object])
};
export { l as default, i as usePortalContainer };